import { Theme } from '@rossum/ui/material';
import { lineElementClasses } from '@rossum/ui/x-charts-pro';

export const getChartColors = (theme: Theme) => ({
  primary: theme.palette.info.main,
  secondary: '#47D5F5',
});

export const getComposedChartStyles = ({
  theme,
  primaryAxisId,
  secondaryAxisId,
}: {
  theme: Theme;
  primaryAxisId: string;
  secondaryAxisId: string;
}) => {
  const { secondary, primary } = getChartColors(theme);
  return {
    surfaceStyles: {
      // The library auto-generates class names following the pattern Mui<Component>-series-<seriesId>
      [`& .${lineElementClasses.series}-${secondaryAxisId}`]: {
        stroke: `${secondary}`,
      },
      [`& .${lineElementClasses.series}-${primaryAxisId}`]: {
        stroke: `${primary}`,
      },
    },
  };
};
